/* global axios */
// NOTICE: KAPTION-INTEGRATION - Dedicated WhatsApp request-contact-info API.
export const createContactInfoRequest = (accountId, conversationId, data) =>
  axios.post(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_contact_info_request`,
    data
  );
